var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:education"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 33.7988L24.5 39.705L14 33.7988V27.5586L11 25.8919V35.5532L24.5 43.147L38 35.5532V25.8919L35 27.5586V33.7988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.5 5.23639L3.5 16.1253V18.7253L24.5 30.3917L42.5 20.392V28.676H45.5V16.1253L24.5 5.23639ZM39.5 18.6268L36.5 20.2934L24.5 26.9604L12.5 20.2934L9.5 18.6268L7.42072 17.4716L24.5 8.6157L41.5793 17.4716L39.5 18.6268Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCap);
export default __webpack_public_path__ + "static/media/whiteCap.6ac70a3174d264d45a6749dfc3724bb0.svg";
export { ForwardRef as ReactComponent };